import React, { Fragment } from 'react'
import styled from '@emotion/styled'
import { components, type MenuProps } from 'react-select'
import { Text, TextButton, spacing } from '@retailer-platform/shared-components'
import { useDomainMessages } from 'domains/aggregate-store-performance/utils/domain/intl'
import {
  MenuTitle,
  MenuActionButton,
  MenuActionsApplyContainer,
} from 'domains/aggregate-store-performance/utils/helpers/Dropdown.utils'
import { type StoreGroupDropdownOption } from 'domains/aggregate-store-performance/components/store-group-dropdown/utils/StoreGroupDropdown.types'

const StyledTextButton = styled(TextButton)({
  border: 'none',
  marginTop: spacing.X16,
})

const ActionsCreateContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  margin: `${spacing.X4} ${spacing.X20} ${spacing.X20}`,
})

export const Menu = (props: MenuProps<StoreGroupDropdownOption>) => {
  const messages = useDomainMessages({
    menuTitle: 'aggregateStorePerformanceDomain.storeGroupDropdown.menuTitle',
    edit: 'aggregateStorePerformanceDomain.storeGroupDropdown.edit',
    create: 'aggregateStorePerformanceDomain.storeGroupDropdown.create',
    clear: 'aggregateStorePerformanceDomain.storeGroupDropdown.clear',
    apply: 'aggregateStorePerformanceDomain.storeGroupDropdown.apply',
  })

  return (
    <components.Menu {...props}>
      <Fragment>
        <MenuTitle>
          <Text size="medium" weight="bold">
            {messages.menuTitle}
          </Text>
        </MenuTitle>
        {props.children}
        <ActionsCreateContainer>
          <StyledTextButton onClick={props.selectProps.onEditStoreGroupsClicked}>
            <Text size="medium" weight="bold">
              {messages.edit}
            </Text>
          </StyledTextButton>
          <StyledTextButton onClick={props.selectProps.onCreateStoreGroupClicked}>
            <Text size="medium" weight="bold">
              {messages.create}
            </Text>
          </StyledTextButton>
        </ActionsCreateContainer>
        <MenuActionsApplyContainer>
          <MenuActionButton variant="secondary" onClick={props.selectProps.onClear}>
            {messages.clear}
          </MenuActionButton>
          <MenuActionButton onClick={props.selectProps.onSave}>{messages.apply}</MenuActionButton>
        </MenuActionsApplyContainer>
      </Fragment>
    </components.Menu>
  )
}
